<template>
  <div style="overflow: scroll; overflow-x: hidden" ref="scrollContainer">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref, watch } from "vue"

export default defineComponent({
  name: "InfiniteScrollLoader",
  props: {
    loading: {
      type: Boolean,
    },
    allLoaded: {
      type: Boolean,
    },
  },
  setup(props, context) {
    const scrollContainer = ref(null) // FIXME after Vue 3: useTemplateRef("scrollContainer")

    const emitLoad = () => {
      if (props.loading || props.allLoaded) {
        return
      }
      context.emit("load")
    }

    const handleScroll = async () => {
      if (scrollContainer.value === null) {
        return
      }
      const container: any = scrollContainer.value
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 200
      ) {
        emitLoad()
      }
    }

    onMounted(() => {
      // Only after mount the DOM ref is available
      watch(
        () => props.loading,
        async (loading) => {
          if (!loading) {
            await handleScroll()
            setTimeout(() => handleScroll(), 3000)
          }
        },
        { immediate: true }
      )

      scrollContainer.value.addEventListener("scroll", handleScroll)
    })

    // Remove scroll event listener when the component is unmounted
    onUnmounted(() => {
      scrollContainer.value?.removeEventListener("scroll", handleScroll)
    })

    return {
      scrollContainer,
    }
  },
})
</script>
